export const nameRegEx = /^[a-zA-ZäÄöÖüÜßÀÂÆÇÈÉÊËÎÏÔŒÙÛŸàâæçèéêëîïôœùûÿ\s-]+$/;
export const cityRegEx = /^[a-zA-Z0-9äÄöÖüÜßÀÂÆÇÈÉÊËÎÏÔŒÙÛŸàâæçèéêëîïôœùû./\\()#\s-]*$/;
export const streetRegEx = /^[a-zA-Z0-9äÄöÖüÜßÀÂÆÇÈÉÊËÎÏÔŒÙÛŸàâæçèéêëîïôœùû./&+()'\s-]*$/;
export const addressAdditionRegEx = /^[a-zA-Z0-9äÄöÖüÜßÀÂÆÇÈÉÊËÎÏÔŒÙÛŸàâæçèéêëîïôœùû.,/&+()#\s-]*$/;
export const houseNumberRegEx = /^[0-9]+[a-zA-Z0-9äÄöÖüÜßÀÂÆÇÈÉÊËÎÏÔŒÙÛŸàâæçèéêëîïôœùû./&+\s-]*$/;
export const  postalCodeRegEx = {
    AT: /^\d{4}$/,
    BE: /^\d{4}$/,
    CH: /^\d{4}$/,
    CZ: /^\d{3} ?\d{2}$/,
    DE: /^\d{5}$/,
    FR: /^\d{3} ?\d{2}$/,
    IT: /^\d{5}$/,
    NO: /^\d{4}$/,
    NL: /^\d{4} ?[A-Z]{2}$/,
    SE: /^\d{3} ?\d{2}$/,
};
export const postalCodeRestRegEx = /^[0-9A-Za-z-]{3,6}$/;
export const couponRegEx = /^[a-zA-Z0-9_]{0,24}$/;
export const dateDayMonthRegEx = /^[0-9]{1,2}$/;
export const dateYearRegEx = /^[0-9]{4}$/;
export const newPasswordRegEx = /(?=.{8,35}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[\d])(?=.*[.,\-\/&+ß$()=?!@*_öÖäÄüÜ])(.*\S+.*)/;
export const telNumberRegEx = /^(?:[0-9/()+\s] ?){6,16}$/;
export const mobileNumberRegEx = /^(?:[0-9/()+\s] ?){6,15}$/;
export const germanIbanRegEx = /^DE[0-9]{20}$/;
export const bankAccountOwnerRegEx = /^[a-zA-ZäÄöÖüÜßÀÂÆÇÈÉÊËÎÏÔŒÙÛŸàâæçèéêëîïôœùûÿ\s-]+$/;
export const allowedSpecialCharRegEx = /([.,\-\/&+ß$()=?!@*_öÖäÄüÜ])+/;
export const digitRegEx = /[0-9]+/;
export const letterRegEx = /[a-zA-Z]+/;
